import { byShortcut } from "@imi/ui/helpers/predicate.js";
import { useKeyboard } from "@imi/ui/hooks/useKeyboard.js";
import { useEffect, useRef } from "react";

type useNumberEventsProps = {
  incrementValueBy: (step: number) => void;
  isFocused: boolean;
};

export function useNumberFieldEvents({
  incrementValueBy,
  isFocused,
}: useNumberEventsProps) {
  const ref = useRef<HTMLLabelElement>(null);

  useKeyboard(byShortcut("ArrowUp"), () => incrementValueBy(1), {
    target: ref,
  });
  useKeyboard(byShortcut("ArrowDown"), () => incrementValueBy(-1), {
    target: ref,
  });

  useEffect(() => {
    function onWheel(e: WheelEvent) {
      if (!isFocused) return;
      e.preventDefault();
      if (e.deltaY < 0) {
        incrementValueBy(1);
      } else if (e.deltaY > 0) {
        incrementValueBy(-1);
      }
    }

    const controller = new AbortController();
    const input = ref.current;
    input?.addEventListener("wheel", onWheel, {
      passive: false,
      signal: controller.signal,
    });
    return () => {
      controller.abort();
    };
  }, [isFocused, incrementValueBy]);

  return ref;
}
